<template>

  <q-input
      ref="number_input"
      class="mw-form-v2-input"
      :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"
      v-model.number="fieldValue"
      :hide-bottom-space="hide_bottom_space"
      type="number"
      :label="field.layout_injected_label ? field.layout_injected_label : field.label"

      lazy-rules
      debounce="1000"
      :rules="field.required ? [ val => val || requiredText] : []"
  >
    <template v-slot:label>
      {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
    </template>

  </q-input>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{},
    hide_bottom_space: null
  },
  data() {
    return {

    };
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.number_input.focus();
    }
  },
  components: {OptionalLabel},
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type something';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
